
import { Component, Vue } from 'vue-property-decorator';
import { StayRoomModule } from '@/store/modules/stayRoom';
import {
  addStayRoom,
  defaultStayRoom,
  getStayRoom,
  updateStayRoom,
} from '@/api/stayRoom';
import Basic from './components/Basic.vue';
import ApplicationInfo from './components/ApplicationInfo.vue';
import RefundRules from './components/RefundRules.vue';
import Charge from './components/Charge.vue';
import { getStayRoomOptionTypeList } from '@/api/stayOptionType';

@Component({
  components: {
    Basic,
    ApplicationInfo,
    RefundRules,
    Charge,
  },
})
export default class extends Vue {
  mounted() {
    this.setForm();
  }

  get form() {
    return StayRoomModule.form;
  }

  private activeTab = 'basic';

  private loading = true;

  private async setForm() {
    if (this.$route.params.idx) {
      StayRoomModule.setIsNew(false);
      getStayRoom(this.$route.params.idx).then((res) => {
        StayRoomModule.setForm({
          ...res.data,
          optionTypes: [],
        });
        getStayRoomOptionTypeList().then((res2) => {
          res2.data.forEach((optionType: any, index: number) => {
            StayRoomModule.form.optionTypes.push(optionType);
            const options: any = [];
            optionType.options.forEach((option: any) => {
              const optionIdx = this.form.options.findIndex((x: any) => x.optionIdx === option.idx);
              if (optionIdx < 0) {
                options.push({
                  typeIdx: optionType.idx,
                  optionIdx: option.idx,
                  name: option.name,
                  useStatus: false,
                });
              } else {
                options.push({
                  idx: this.form.options[optionIdx].idx,
                  typeIdx: optionType.idx,
                  optionIdx: option.idx,
                  name: option.name,
                  useStatus: this.form.options[optionIdx].useStatus,
                });
              }
            });
            this.form.optionTypes[index].options = options;
          });
        });
        StayRoomModule.setForm(this.form);
        this.loading = false;
      });
    } else {
      StayRoomModule.setIsNew(true);
      const defaultForm = defaultStayRoom();
      await StayRoomModule.setForm({ ...defaultForm });
      getStayRoomOptionTypeList().then((res) => {
        res.data.forEach((optionType: any) => {
          this.form.optionTypes.push({ ...optionType });
        });
      });
      this.loading = false;
    }
  }

  private async handleClickSave() {
    const valid = await this.validateForm('basicForm', 'form');
    // if (valid) valid = await this.validateForm('chargeForm', 'form', 'charge');
    if (valid) {
      this.loading = true;
      this.convertOptions();
      if (this.$route.params.idx) {
        updateStayRoom(this.$route.params.idx, this.form).then(() => {
          this.$message.success('성공적으로 객실을 수정했습니다.');
          this.$router.push({ name: 'StayRoom', query: { ...this.$route.query } });
          this.loading = false;
        });
      } else {
        addStayRoom(this.form).then(() => {
          this.$message.success('성공적으로 객실을 등록했습니다.');
          this.$router.push({ name: 'StayRoom', query: { ...this.$route.query } });
          this.loading = false;
        }).catch((error) => {
          if (error.response.status === 400) {
            this.$message.warning('숙박시설 정보를 등록해주세요.');
            this.$router.push({ name: 'Stay' });
          }
        });
      }
    }
  }

  /**
   * tabRef: 탭 콘텐츠 ref명
   * formRef: 콘텐츠ref 속 form ref명
   * tabName: 탭 값
   */
  private async validateForm(tabRef: string, formRef: string) {
    return new Promise((resolve: any) => {
      (this.$refs[tabRef] as any).$refs[formRef].validate().then((valid: boolean) => {
        resolve(true);
      }).catch(() => {
        resolve(false);
      });
    });
  }

  private convertOptions() {
    let options: any = [];
    this.form.optionTypes.forEach((optionType: any) => {
      options = options.concat(optionType.options);
    });
    this.form.options = options;
  }
}
